import moment from "moment"
import storePersist from "../../redux/storePersist"
import * as R from "ramda"
import _ from "lodash"
import { DecodedToken, decodeToken } from "./decode-jwt"

export const deepCopy = (obj: any) => JSON.parse(JSON.stringify(obj))
export const copyTextToClipBoard = async (text: string) => {
  await navigator.clipboard.writeText(text)
}
export const getFormattedDate = ({ date }: any) => (
  moment
    .utc(date)
    .format('YYYY-MM-DD hh:mm:ss a')
)

export const format = (date: any) => {
  if (date) {
    const localDateFormatted = moment(date).local()
      .format('YYYY-MM-DD hh:mm:ss a')
    return localDateFormatted
  }
  return ''
}

export const formatDate = (date: any) => {
  if (date) {
    const localDateFormatted = moment(date).local()
      .format('YYYY-MM-DD')
    return localDateFormatted
  }
  return ''
}
export const currency = (money: any) => {
  var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
  const countryCode = metaTokenMetaData.CountryCode;
  const languageCode = metaTokenMetaData.LanguageCode;
  const currencyCode = metaTokenMetaData.CurrencyCode;

  const moneyArr: any = _.split(
    money,
    '.'
  )

  let finalMoneyString = Intl.NumberFormat(
    `${languageCode}-${countryCode}`,
    {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      maximumSignificantDigits: 3
    }
  ).format(moneyArr[0])

  if (moneyArr?.length > 1) {
    finalMoneyString += `.${moneyArr[1]}`
  }

  return finalMoneyString
}
export const getCurrencySymbol = (label: any) => {
  let currencySymbol: any = null;
  const countryCode = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization?.CountryCode;
  const languageCode = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization?.LanguageCode;
  const currencyCode = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization?.CurrencyCode
  if (label?.length > 0 &&
    R.find((subString) => label.indexOf(subString) > -1)([
      'Price',
      'Cost',
      'Amount',
      'Amt',
      'Charge',
      'Charges',
      'MRP'
    ])
  ) {
    // const options = { style: 'currency', currency: currencyCode };
    // const us = new Intl.NumberFormat(languageCode, options);
    const valueWithCurrency = Number(0).toLocaleString(languageCode, {
      style: "currency",
      currency: currencyCode,
      minimumFractionDigits: 2
    });
    const valueWithoutCurrency = valueWithCurrency.replace(Number(0).toLocaleString(languageCode, {
      minimumFractionDigits: 2
    }), "")

    currencySymbol = valueWithoutCurrency
  }
  return currencySymbol
}
export const getAccountTypeChannalName = () => {
  // const token = storePersist?.get("accessToken")?.current?.JwtToken;
  const token = localStorage.getItem("access-token");
  if (token) {
    const decodedToken: DecodedToken | null = decodeToken(token);
    if (decodedToken) {

      return decodedToken;
    } else {
      // Handle invalid token
      // Redirect to login page, show error message, etc.
      return null;
    }
  } else {
    // Handle case when token is not present
    // Redirect to login page, show error message, etc.
    return null;
  }
}

export const transformCardValues = (cardValues: any) => {
  const values = deepCopy(cardValues)
  const transformedValues: any = [];
  let ictr = 0
  R.map(
    (valueSet) => {
      transformedValues.push([])
      R.map(
        (value) => {
          transformedValues[ictr].push({
            [value.field]: value.value
          })
          return value
        },
        valueSet
      )
      transformedValues[ictr] = R.mergeAll(transformedValues[ictr])
      ictr += 1
      return valueSet
    },
    values
  )
  return transformedValues
}
const keyMapped = (data: any) => {
  let type = ''
  if (data === 'src') {
    type = 'image'
  } else if (data === 'video') {
    type = 'video'
  } else if (data === 'email') {
    type = 'email'
  } else if (data === 'phone') {
    type = 'number'
  } else if (data === 'whatsapp') {
    type = 'number'
  } else {
    type = 'text'
  }

  return type
}

export const getBodyType = (id: any) => {
  switch (id) {
    case 10:
      return 'Open Type';
    case 20:
      return 'Close Type';
    case 30:
      return 'Refrigerator Type';
    default:
      return 'Unknown Type';
  }
};

export const transformBackCardValues = (cardValues: any) => {
  const values = deepCopy(JSON.parse(cardValues))
  const transformedValues: any = [];
  let ictr = 0
  R.map(
    (valueSet) => {
      transformedValues.push([])
      R.mapObjIndexed(
        (value, key) => {
          transformedValues[ictr].push({
            field: key,
            type: keyMapped(key),
            value
          })
        },
        valueSet
      )
      ictr += 1
      return valueSet
    },
    values
  )
  return JSON.stringify(transformedValues)
}

export function updateNestedValue(obj, path, value) {
  if (!path) {
    return obj
  }
  const keys = path.split('.');
  let current = obj;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    const isArrayIndex = !isNaN(key) && parseInt(key, 10) == key;

    if (isArrayIndex) {
      // If it's an array index, ensure the current level is an array
      if (!Array.isArray(current)) {
        current = [];
      }
    } else {
      if (!current[key] || typeof current[key] !== 'object') {
        current[key] = {};
      }
    }
    current = current[key];
  }

  current[keys[keys.length - 1]] = value;
  return obj;
}

export const getHostName = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return "ulip.digiit.io"
  } else {
    return window.location.hostname
  }
}
export const getGatewayId = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return process.env.REACT_APP_GATEWAY_ID
  } else {
    return window.location.hostname
  }
}
export const getGatewayuri = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return process.env.REACT_APP_GATEWAY_URI
  } else {
    return window.location.origin
  }
}




export const getOrigin = () => {
  const host = window.location.hostname
  let baseUrl;
  if (host.includes(".ishipx.digiit.io") || host.includes(".ishipx.digiit.ai")) {
    const parts = host.split(".");
    const subdomain = parts[0]; // e.g., "agri"
    const tld = parts[parts.length - 1]; // "io" or "ai"
    baseUrl = `https://${subdomain}.csp.digiit.${tld}`;
  } else {
    switch (host) {
      case 'tranze.lx.digiit.io':  // QDP
        baseUrl = "https://tranze.csp.digiit.io";
        break;
      case 'tranze.ishipx.digiit.io':  // Shipx
        baseUrl = "https://tranze.csp.digiit.io";
        break;

      case 'localhost':
        // QDP
        baseUrl = "https://ulip.csp.digiit.io"

        break;
      default:
        const origin = window.location.origin;
        baseUrl = origin.replace(/\.digiit\./, ".csp.digiit.");
    }
  }
  return baseUrl;
}